export default "__VITE_ASSET__7450498e__"